export default __webpack_public_path__ + "static/media/activity-6.cf45a544.png";